// import 'firebase/firestore';
// import 'firebase/storage';
// import 'firebase/auth';
// import 'firebase/functions';
// import 'firebase'

// Dev environment
// export const firebaseConfig = {
//     apiKey: "AIzaSyAiVF3-GYqnompfLvCToSBCcs4HND0s6Bk",
//     authDomain: "website-estimation-immobiliere.firebaseapp.com",
//     databaseURL: "https://website-estimation-immobiliere.firebaseio.com",
//     projectId: "website-estimation-immobiliere",
//     storageBucket: "website-estimation-immobiliere.appspot.com",
//     messagingSenderId: "609866508045",
//     appId: "1:609866508045:web:22444214fc18e206b3b244",
//     measurementId: "G-58EQEX4DM4"
// };

// prod environment
export const firebaseConfig = {
    apiKey: "AIzaSyDKUGHP_aDi--W8prH3CtQIOc2cjkh3FRc",
    authDomain: "agenz-website-prod.firebaseapp.com",
    projectId: "agenz-website-prod",
    storageBucket: "agenz-website-prod.appspot.com",
    messagingSenderId: "1032404158043",
    appId: "1:1032404158043:web:c5a936822f9d32837b217e",
    measurementId: "G-LL9GHGZGV6"
  };

// Initialize Firebase
// firebase.initializeApp(firebaseConfig);
// firebase.firestore();
// firebase.storage();
// firebase.functions();
